import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent implements OnInit {
  @Output() Emit = new EventEmitter();
  notificationIcon = <any>{
    general: '-201px -568px',
    chat: '-112px -275px',
    mail: '-113px -107px',
    success: '-19px -568px',
    error: '-114px -568px',
    report: '-200px -390px',
    hint: '-113px -52px',
    warn: '-113px -52px',
    update: '-201px -165px',
    blocked: '-17px -629px',
    locked: '-17px -629px',

  }
  constructor(
    public snackBarRef: MatSnackBarRef<ToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }
  countDown = 8
  timer: any;
  ngOnInit() {
    if (!!this.data && !!this.data.type && !this.data.icon) {
      if (this.data.type == 'success') {
        this.data.icon = 'done_all'
      } else if (this.data.type == 'warn') {
        this.data.icon = 'error_outline'
      } else if (this.data.type == 'error') {
        this.data.icon = 'help_outline'
      }
    }
    if (!!this.data && this.data.timer) {
      this.countDown = this.data.timer / 1000;
    }
    this.timer = setInterval(() => { this.countDown = this.countDown - 1; if (this.countDown === 0) { clearInterval(this.timer); } }, 1000);
  }
  notificationAcess() {
    Notification.requestPermission();

  }
  emitHandle() {
    this.Emit.emit('ssssssssss');
  }
}
